<template>
  <v-footer v-if="!props.user" class="d-flex flex-column pa-0" app>
    <div class="bg-surface-variant d-flex w-100 align-center px-4 py-2">
      <v-spacer></v-spacer>
      <v-btn
        v-for="social in socialLinks"
        :key="social.icon"
        class="mx-2"
        :icon="social.icon"
        :href="social.href"
        target="_blank"
        variant="text"
        size="small"
      ></v-btn>
      <v-spacer></v-spacer>
    </div>

    <div class="px-4 py-2 bg-grey-darken-3 text-center w-100">
      <div class="text-caption">
        {{ $t('shell_footer_copyright', String(currentYear)) }}
      </div>
      
      <div v-if="props.client" class="text-caption mt-1">
        {{ props.client.version }} {{ props.client.date }}
      </div>
    </div>
  </v-footer>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  user: {
    type: Object,
    default: null,
  },
  client: {
    type: Object,
    default: null,
  },
});

const currentYear = computed(() => new Date().getFullYear());

const socialLinks = ref([
  { icon: 'mdi-twitter', href: 'https://twitter.com/readychek' },
  { icon: 'mdi-facebook', href: 'https://facebook.com/readychek' },
  { icon: 'mdi-linkedin', href: 'https://www.linkedin.com/company/readychek' },
  { icon: 'mdi-instagram', href: 'https://www.instagram.com/readychek' },
  { icon: 'mdi-home', href: 'https://www.readychek.com' },
]);
</script>
